<ng-template #template>
  <div [class]="model.cssClass" >
    <ng-template *ngFor="let element of model.elements" [component]="{ name: element.componentName, data: element.componentData }"></ng-template>
  </div>
</ng-template>